import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  minimizeSection: {
    border: 'none',
    borderRadius: 0,
    borderBottom: `1px solid ${lightGrey}`,
    '&:not(:last-child)': {
      marginBottom: 0
    }
  },
  sectionHeader: {
    paddingLeft: 0
  },
  body: {
    padding: 0,
    borderTop: 'none'
  }
})

export default useStyles
